import { render, staticRenderFns } from "./BCDList.vue?vue&type=template&id=4393dbe3&scoped=true"
import script from "./BCDList.vue?vue&type=script&lang=js"
export * from "./BCDList.vue?vue&type=script&lang=js"
import style0 from "./BCDList.vue?vue&type=style&index=0&id=4393dbe3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393dbe3",
  null
  
)

export default component.exports